import { Outlet } from 'react-router-dom';

import ErrorBoundary from '@/app/error-boundary';
import FpjsTracker from '@/components/fingerprint/fpjs-tracker';
import { Header } from '@/components/header';
import NotificationsDialog from '@/features/account/components/notifications-dialog';
import { useHashScroll } from '@/hooks';

import AccountHandler from '../handlers/account-handler';
import ApiHandler from '../handlers/api-handler';
import DiscountGroupsHandler from '../handlers/discount-groups-handler';
import EventHandler from '../handlers/event-handler';
import FundedAccountBanner from '../header/funded-account-banner';
import MaintenanceBanner from '../header/maintenance-banner';
import CapitalResultModal from '../header/modals/capital-result-modal';
import CapitalTourModal from '../header/modals/capital-tour-modal';
import DiscountsModal from '../header/modals/discounts-modal';
import ReferralLinkModal from '../header/modals/referral-link-modal';
import RealtimeConnectionLostBanner from '../header/realtime-connection-lost-banner';
import TrendingBanner from '../header/trending-banner';
import ListingsToast from '../toast/listings-toast';

export default function RootLayout() {
  useHashScroll();
  return (
    <ErrorBoundary>
      <ApiHandler />
      <EventHandler />
      <AccountHandler />
      <DiscountGroupsHandler />
      <FpjsTracker />
      <CapitalResultModal />
      <DiscountsModal />
      <ReferralLinkModal />
      <CapitalTourModal />
      <div className="flex h-full flex-col">
        <MaintenanceBanner />
        <RealtimeConnectionLostBanner />
        <FundedAccountBanner />
        <Header />
        <TrendingBanner />
        <main className="h-full">
          <Outlet />
        </main>
      </div>
      <ListingsToast />
      <NotificationsDialog />
    </ErrorBoundary>
  );
}
